var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _vm._m(0),
      _c(
        "el-menu",
        {
          staticClass: "left-menu",
          attrs: { router: true, mode: "horizontal" },
          on: { select: _vm.handSelect }
        },
        [
          _vm._l(_vm.routes, function(route, menuIndex) {
            return !(route.path === "/" || route.path === "/back")
              ? _c(
                  "el-popover",
                  {
                    key: route.id,
                    ref: "subMenuPop" + menuIndex,
                    refInFor: true,
                    attrs: { placement: "bottom", trigger: "click" },
                    model: {
                      value: route.isShowMenu,
                      callback: function($$v) {
                        _vm.$set(route, "isShowMenu", $$v)
                      },
                      expression: "route.isShowMenu"
                    }
                  },
                  [
                    _c("menuDetail", {
                      attrs: { route: route, "all-routes": _vm.routes },
                      on: { hiddenProver: _vm.hiddenProver }
                    })
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._l(_vm.routes, function(route, menuIndex) {
            return !_vm.isZqpt || route.path === "/back"
              ? _c(
                  "el-menu-item",
                  {
                    directives: [
                      {
                        name: "popover",
                        rawName: "v-popover",
                        value: "subMenuPop" + menuIndex,
                        expression: "'subMenuPop'+menuIndex"
                      }
                    ],
                    key: route.id,
                    staticClass: "active-text-color",
                    attrs: { index: _vm.getIndex(route, menuIndex) }
                  },
                  [
                    _c("template", { slot: "title" }, [
                      _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.handleMenuActive(menuIndex)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.showName(route)))]
                      )
                    ])
                  ],
                  2
                )
              : _vm._e()
          })
        ],
        2
      ),
      _c("div", { staticClass: "right-menu" }, [
        _c("div", { staticClass: "avatar-container right-menu-item" }, [
          _c("img", {
            staticClass: "houtai-user",
            attrs: { src: _vm.userUrl }
          }),
          _c("div", { staticClass: "avatar-wrapper-name" }, [
            _vm._v(_vm._s(_vm.userName))
          ]),
          !_vm.isZqpt && _vm.userTheme
            ? _c("img", {
                staticClass: "logout",
                staticStyle: { width: "1vw", "margin-right": "0.5vw" },
                attrs: { src: "static/img/logout.png" }
              })
            : _vm._e(),
          !_vm.isZqpt
            ? _c(
                "div",
                { staticClass: "avatar-wrapper", on: { click: _vm.logout } },
                [_vm._v(" 退出 ")]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("div", { staticClass: "titleSystem" }, [_vm._v("福州文化宫")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }